import React from 'react';
import { Typography } from 'antd';

const { Title } = Typography;

const UiTitle = ({ children, style, ...restProps }) => {
    const mergedStyle = {
        fontSize: "18px"
    };
    return <Title style={mergedStyle} {...restProps}>{children}</Title>;
};

export default UiTitle;
